import Icon from 'snippets/icon/icon'

const selectors = {
  CONDITION_TAG_PREFIX: 'condition_'
}

function ProductCardCondition({ tags, className = '' }) {
  const conditions = tags
    .filter((item) => item.startsWith(selectors.CONDITION_TAG_PREFIX))
    .map((item) => item.replace(selectors.CONDITION_TAG_PREFIX, '').replace('-', ' '))

  return (
    conditions.length > 0 && (
      <div className={`hidden flex-wrap gap-2 mt-auto md:flex ${className}`}>
        <p className="flex w-fit items-center gap-1 rounded bg-grey-100 px-2 py-1.5 text-xs capitalize text-grey-900">
          <Icon name="icon-check" viewBox="0 0 10 10" className="size-2.5 flex-none text-grey-500" />
          {conditions[0]}
        </p>
        {conditions.length > 1 && <p className="h-[22px] w-[26px] rounded bg-grey-100 text-center">...</p>}
      </div>
    )
  )
}

export default ProductCardCondition
